import React, {useState} from 'react'
import {NavLink} from 'react-router-dom';
import Footer from '../footer'
import ContactForm from './ContactForm';
import Header from './Headers';

const Contact = () => {
    const [show1, setShow1] = useState(false)
    const [show2, setShow2] = useState(false)
    const [show3, setShow3] = useState(false)
    const [show4, setShow4] = useState(false)
    const [show5, setShow5] = useState(false)
    const [show6, setShow6] = useState(false)
    const [show7, setShow7] = useState(false)
    const [show8, setShow8] = useState(false)
    const [show9, setShow9] = useState(false)
    const [show10, setShow10] = useState(false)

    const toggleQueries1 = () => {
        setShow1(!show1)
    }
    const toggleQueries2 = () => {
        setShow2(!show2)
    }
    const toggleQueries3 = () => {
        setShow3(!show3)
    }
    const toggleQueries4 = () => {
        setShow4(!show4)
    }
    const toggleQueries5 = () => {
        setShow5(!show5)
    }
    const toggleQueries6 = () => {
        setShow6(!show6)
    }
    const toggleQueries7 = () => {
        setShow7(!show7)
    }
    const toggleQueries8 = () => {
        setShow8(!show8)
    }
    const toggleQueries9 = () => {
        setShow9(!show9)
    }
    const toggleQueries10 = () => {
        setShow10(!show10)
    }

    return (
        <div>
            <Header/>
            <section className="pdtb-20">
                <section className="breadcrumbs">
                    <div className="container">
                        <div className="d-flex justify-content-between align-items-center">
                            <h2>Contact Us</h2>
                            <ol>
                                <li><a href="/">Home</a></li>
                                <li>Contact Us</li>
                            </ol>
                        </div>
                    </div>
                </section>
            </section>
            <section>
                <section id="services" className="services" data-aos="fade-up">
                    <div className="container" data-aos="fade-up">
                        <div className="section-titles">
                            <h3 className="heading_tow">CONTACT US</h3>
                        </div>
                    </div>
                </section>
                <div className="container aos-init aos-animate" data-aos="fade-up">
                    <div className="row">
                        <div className="col-lg-12 col-md-12 d-flex align-items-stretch aos-init aos-animate"
                             data-aos="fade-up" data-aos-delay="300">
                            <iframe
                                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14018.550326060908!2d77.24176336977537!3d28.550611200000002!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce3dab7ea72b3%3A0x27f00c7fe455e665!2sRevFin%20Services%20Private%20Limited!5e0!3m2!1sen!2sin!4v1652420035768!5m2!1sen!2sin"
                                style={{
                                    width: "100%",
                                    height: "375px"
                                }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade"
                                title='revfin-location'></iframe>
                        </div>
                    </div>
                </div>
                <div className="container aos-init aos-animate" data-aos="fade-up">
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        flexWrap: 'wrap',
                        marginTop: '30px'
                    }}>
                        <div>
                            <h3>Address</h3>
                            <p>REVFIN SERVICES PRIVATE LIMITED<br/>
                                2nd Floor, E-Block International Trade Tower <br/>Nehru Place<br/> New Delhi<br/> South
                                Delhi DL 110019 IN</p>
                        </div>
                        <div>
                            <h3>Email</h3>
                            <a href='mailTo:care@revfin.in' className='contact-us-link'><p>care@revfin.in</p></a>
                        </div>

                        <div><h3>Phone</h3>
                            <a href='tel:+91-8686738738' className='contact-us-link'><p>+91-8686738738</p></a>
                        </div>


                    </div>
                </div>
            </section>
            <section>
                <section id="services" className="services" data-aos="fade-up">
                    <div className="container" data-aos="fade-up">
                        <div className="section-titles">
                            <h3 className="heading_tow">FREQUENTLY ASKED QUESTIONS</h3>
                        </div>
                    </div>
                </section>
                <div className="container aos-init aos-animate" data-aos="fade-up">
                    <div className="row">
                        <div className="col-lg-6 col-md-6 aos-init aos-animate" data-aos="fade-up" data-aos-delay="300">
                            <div className='heading-faq'>
                                <h3 className="fz-20">About Revfin</h3>
                                <div className='faq-question-toggle'>
                                    {
                                        !show1 ? <i id='iconId' className="bi bi-chevron-right"
                                                    onClick={toggleQueries1}></i> :
                                            <i id='iconId' className="bi bi-chevron-down" onClick={toggleQueries1}></i>
                                    }
                                </div>
                            </div>
                            {show1 && (
                                <div><p>Revfin is a digital lending platform that allows individual users to apply for
                                    loans. All loans are issued through Aristo Securities Private Limited (a Non-Banking
                                    Finance Company, NBFC, regulated by the RBI), a subsidiary of Revfin Services
                                    Private Limited (Revfin). To know more about us, <NavLink to="/about-us"
                                                                                              className='contact-us-link'>click
                                        here.</NavLink></p>
                                    <div className="full-w mgt-15">
                                        <div className='heading-faq'>
                                            <h3 className="fz-20">Some of the key features of our value proposition
                                                include:</h3>
                                        </div>
                                        <p><b>RevLoan</b> – a unique revolving credit limit, which you can use and repay
                                            at any time per your convenience. With this limit, you will never need to
                                            apply for a small loan again! To learn more about our products,
                                            please <NavLink to="/product" className='contact-us-link'>click
                                                here.</NavLink></p>
                                        <p><b>Rev-a-thon</b> – this is a reward scheme where you can earn points (Revs)
                                            for repaying on time, referring your friends or even for logging on to our
                                            App.</p>
                                        <p><b>Rev-a-mate</b> – now you can help your friends and family get access to a
                                            loan by referring them. You can also earn rewards while doing so.</p>
                                    </div>
                                </div>)}
                        </div>
                        <div className="col-lg-6 col-md-6 aos-init aos-animate" data-aos="fade-up" data-aos-delay="300">
                            <div className='heading-faq'>
                                <h3 className="fz-20">What loan products do you offer?</h3>
                                <div className='faq-question-toggle'>
                                    {
                                        !show2 ? <i id='iconId' className="bi bi-chevron-right"
                                                    onClick={toggleQueries2}></i> :
                                            <i className="bi bi-chevron-down" onClick={toggleQueries2}></i>
                                    }
                                </div>
                            </div>
                            {show2 && <div>
                                <p className="mgt-5">We currently offer two types of loans to our customers, Personal
                                    Loan and RevLoan.</p>
                                <p className="mgt-5">Our personal loan is a closed ended unsecured credit product. With
                                    a personal loan, you borrow a fixed amount from us for a variety of purposes and
                                    repay it back in equal monthly installments over the term of the loan. We charge an
                                    interest on the amount lent and apply fees/charges</p>
                                <p className="mgt-5">Our RevLoan is an unsecured credit limit that you can use at any
                                    time per your need. In this, you can draw down any amount in denominations of
                                    Rs.1,000 up to your credit limit. You are charged a daily usage fee, which needs to
                                    be repaid in full every month.</p>
                            </div>}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-6 col-md-6 aos-init aos-animate" data-aos="fade-up" data-aos-delay="300">
                            <div className='heading-faq'>
                                <h3 className="fz-20">What is Revloan?</h3>
                                <div className='faq-question-toggle'>
                                    {
                                        !show3 ? <i className="bi bi-chevron-right" onClick={toggleQueries3}></i> :
                                            <i className="bi bi-chevron-down" onClick={toggleQueries3}></i>
                                    }
                                </div>
                            </div>
                            {show3 && <div>
                                <p className="mgt-5"><b className="orange">RevLoan</b> a unique revolving credit limit,
                                    which you can use and repay at any time per your convenience. With this limit, you
                                    will never need to apply for a small loan again!</p>
                            </div>}
                        </div>
                        <div className="col-lg-6 col-md-6 aos-init aos-animate" data-aos="fade-up" data-aos-delay="300">
                            <div className='heading-faq'>
                                <h3 className="fz-20">What is your eligibility criteria?</h3>
                                <div className='faq-question-toggle'>
                                    {
                                        !show4 ? <i className="bi bi-chevron-right" onClick={toggleQueries4}></i> :
                                            <i className="bi bi-chevron-down" onClick={toggleQueries4}></i>
                                    }
                                </div>
                            </div>
                            {show4 && <div>
                                <p className="mgt-5">We make lending decisions by taking in to account the information
                                    provided by you in your application, the amount of credit you applied for, together
                                    with any additional information obtained from third party sources like credit
                                    bureaus.</p>

                            </div>}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-6 col-md-6 aos-init aos-animate" data-aos="fade-up" data-aos-delay="300">
                            <div className='heading-faq'>
                                <h3 className="fz-20">How much can I borrow?</h3>
                                <div className='faq-question-toggle'>
                                    {
                                        !show5 ? <i className="bi bi-chevron-right" onClick={toggleQueries5}></i> :
                                            <i className="bi bi-chevron-down" onClick={toggleQueries5}></i>
                                    }
                                </div>
                            </div>
                            {show5 && <div>
                                <p className="mgt-5">How much you can borrow will depending on your individual needs and
                                    circumstances. We offer personal loans between Rs. 20,000 and Rs. 20,00,000.</p>
                                <p className="mgt-5">To check monthly repayments, you can use our EMI calculator.</p>
                            </div>}

                        </div>
                        <div className="col-lg-6 col-md-6 aos-init aos-animate" data-aos="fade-up" data-aos-delay="300">
                            <div className='heading-faq'>
                                <h3 className="fz-20">How much will my EMI be?</h3>
                                <div className='faq-question-toggle'>
                                    {
                                        !show6 ? <i className="bi bi-chevron-right" onClick={toggleQueries6}></i> :
                                            <i className="bi bi-chevron-down" onClick={toggleQueries6}></i>
                                    }
                                </div>
                            </div>
                            {show6 && <div>
                                <p className="mgt-5">You can check monthly repayments by using our EMI calculator.</p>
                            </div>}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-6 col-md-6 aos-init aos-animate" data-aos="fade-up" data-aos-delay="300">
                            <div className='heading-faq'>
                                <h3 className="fz-20">What will I need to apply for a loan?</h3>
                                <div className='faq-question-toggle'>
                                    {
                                        !show7 ? <i className="bi bi-chevron-right" onClick={toggleQueries7}></i> :
                                            <i className="bi bi-chevron-down" onClick={toggleQueries7}></i>
                                    }
                                </div>
                            </div>
                            {show7 && <div>
                                <p className="mgt-5">You will need the following to apply for a loan:</p>
                                <p className="mgt-5">-Internet enabled iOS or Android smartphone</p>
                                <p className="mgt-5">-Your PAN and Aadhar card or any other address proof</p>

                                <p className="mgt-5">-You bank account details</p>
                                <p className="mgt-5">-You bank statements or internet banking log in credentials</p>
                            </div>}
                        </div>
                        <div className="col-lg-6 col-md-6 aos-init aos-animate" data-aos="fade-up" data-aos-delay="300">
                            <div className='heading-faq'>
                                <h3 className="fz-20">How can I apply for a loan?</h3>
                                <div className='faq-question-toggle'>
                                    {
                                        !show8 ? <i className="bi bi-chevron-right" onClick={toggleQueries8}></i> :
                                            <i className="bi bi-chevron-down" onClick={toggleQueries8}></i>
                                    }
                                </div>
                            </div>
                            {show8 && <div>
                                <p className="mgt-5">You can apply for a loan by downloading our iOS or Android
                                    applications.</p>
                            </div>}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-6 col-md-6 aos-init aos-animate" data-aos="fade-up" data-aos-delay="300">
                            <div className='heading-faq'>
                                <h3 className="fz-20">Where can I download your app?</h3>
                                <div className='faq-question-toggle'>
                                    {
                                        !show9 ? <i className="bi bi-chevron-right" onClick={toggleQueries9}></i> :
                                            <i className="bi bi-chevron-down" onClick={toggleQueries9}></i>
                                    }
                                </div>
                            </div>
                            {show9 && <div>
                                <p className="mgt-5">You can download our iOS or Android application.</p>
                            </div>}
                        </div>
                        <div className="col-lg-6 col-md-6 aos-init aos-animate" data-aos="fade-up" data-aos-delay="300">
                            <div className='heading-faq'>
                                <h3 className="fz-20">How can I contact you?</h3>
                                <div className='faq-question-toggle'>
                                    {
                                        !show10 ? <i className="bi bi-chevron-right" onClick={toggleQueries10}></i> :
                                            <i className="bi bi-chevron-down" onClick={toggleQueries10}></i>
                                    }
                                </div>
                            </div>
                            {show10 && <div>
                                <div className="panner_box">
                                    <p>You can reach us in the following ways:</p>
                                    <p>Email: <a href='mailTo:care@revfin.in'
                                                 className='contact-us-link'>care@revfin.in</a></p>
                                    <p>Phone: <a href='tel:+91-8686738738'
                                                 className='contact-us-link'> +91-8686738738</a></p>
                                    <p>Twitter: <a href="https://twitter.com/revfinindia" target="_blank"
                                                   className='contact-us-link'>Click here</a></p>
                                    <p>Instagram: <a href="https://www.instagram.com/revfinserv/" target="_blank"
                                                     className='contact-us-link'>Click here</a></p>
                                    <p>Linkedin: <a href="https://www.linkedin.com/company/revfinserv/" target="_blank"
                                                    className='contact-us-link'>Click here</a></p>
                                    <p>Facebook: <a href="https://www.facebook.com/revfinindia/" target="_blank"
                                                    className='contact-us-link'>Click here</a></p>
                                </div>
                            </div>}
                        </div>
                    </div>
                </div>
            </section>

            <ContactForm/>

            <Footer/>
        </div>
    )
}

export default Contact



// WEBPACK FOOTER //
// ./src/components/Contact.js